import { actions } from '@/store/module/competition/action/actions.js';
import { getters } from '@/store/module/competition/getter/getters.js';
import { mutations } from '@/store/module/competition/mutation/mutations.js';

export const competition = {
	namespaced: true,

	state: () => ({
		competitions: [],
		eventTypes: []
	}),

	actions,
	getters,
	mutations
};
